// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aNqAhDolVBpgiG5sIxq0 {
  margin-top: 2px;
  font-family: var(--font-stack-full-medium);
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  height: 12px;
  width: 12px;
  border-radius: 6px;
}

.Zuu9SjxvBMAbLN4acaZM {
  background: white;
  flex-direction: column;
  gap: 4px;
  width: 300px;
  display: none;
  position: absolute;
  padding: 10px 24px;
  border-radius: 24px;
  box-shadow: 0px 8px 32px 0px rgba(15, 20, 31, 0.1607843137);
  z-index: 10;
}

.P766CpN6PChwLAQUyvC6 {
  height: 1px;
  width: 100%;
  background-color: var(--grey-color-200);
  margin: 2px 0;
}

.GCUj0pJDH7PxOWKkNrAa {
  font-size: 16px;
  line-height: 24px;
  font-family: var(--font-stack-full-medium);
  font-weight: 500;
}

.eZsASsVOdNoJyoVGYYQh {
  font-size: 14px;
  line-height: 20px;
  font-family: var(--font-stack-full-regular);
  font-weight: 350;
  color: black;
  white-space: nowrap;
}

.HsfTZZNu7Vgh1IdxA1JE {
  display: flex;
  gap: 10px;
}

.NtU37verIt8q_G7LE_PB {
  max-height: 257px;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 transparent;
}

.obCzeFKXEaL1gmfcI6Qd {
  margin-top: 8px;
  font-size: 16px;
  line-height: 24px;
  font-family: var(--font-stack-full-medium);
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/components/BubbleChart/BubbleChart.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,0CAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,iBAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2DAAA;EACA,WAAA;AACF;;AAEA;EACE,WAAA;EACA,WAAA;EACA,uCAAA;EACA,aAAA;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;EACA,0CAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;EACA,2CAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,oCAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,0CAAA;EACA,gBAAA;AACF","sourcesContent":[".scoreCircle {\n  margin-top: 2px;\n  font-family: var(--font-stack-full-medium);\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 500;\n  height: 12px;\n  width: 12px;\n  border-radius: 6px;\n}\n\n.scorePopup {\n  background: white;\n  flex-direction: column;\n  gap: 4px;\n  width: 300px;\n  display: none;\n  position: absolute;\n  padding: 10px 24px;\n  border-radius: 24px;\n  box-shadow: 0px 8px 32px 0px #0f141f29;\n  z-index: 10;\n}\n\n.horizontalRule {\n  height: 1px;\n  width: 100%;\n  background-color: var(--grey-color-200);\n  margin: 2px 0;\n}\n\n.bubbleTitle {\n  font-size: 16px;\n  line-height: 24px;\n  font-family: var(--font-stack-full-medium);\n  font-weight: 500;\n}\n\n.circledScoreText {\n  font-size: 14px;\n  line-height: 20px;\n  font-family: var(--font-stack-full-regular);\n  font-weight: 350;\n  color: black;\n  white-space: nowrap;\n}\n\n.circledScore {\n  display: flex;\n  gap: 10px;\n}\n\n.popLeaderList {\n  max-height: 257px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: #d9d9d9 transparent;\n}\n\n.popLeaderName {\n  margin-top: 8px;\n  font-size: 16px;\n  line-height: 24px;\n  font-family: var(--font-stack-full-medium);\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scoreCircle": `aNqAhDolVBpgiG5sIxq0`,
	"scorePopup": `Zuu9SjxvBMAbLN4acaZM`,
	"horizontalRule": `P766CpN6PChwLAQUyvC6`,
	"bubbleTitle": `GCUj0pJDH7PxOWKkNrAa`,
	"circledScoreText": `eZsASsVOdNoJyoVGYYQh`,
	"circledScore": `HsfTZZNu7Vgh1IdxA1JE`,
	"popLeaderList": `NtU37verIt8q_G7LE_PB`,
	"popLeaderName": `obCzeFKXEaL1gmfcI6Qd`
};
export default ___CSS_LOADER_EXPORT___;
